export const WORDSDICT: {[key:string]:string } = {
   'waited': 'The Girl Who Waited is an eleventh Doctor story.',
   'venice': 'The Vampires of Venice is an eleventh Doctor story.',
   'demnos': 'The Cult of Demnos were used by the Mandragora Helix in The Masque of Mandragora.',
   'madame': 'The Girl in the Fireplace is about Madame de Pompadour.',
   'dragon': 'Dragonfire, the Key to the Iceworld space ship, is protected inside the Dragon\'s head.',
   'stenck': 'Commander Stenck leads the Sontarans in The Vanquishers.',
   'heaven': 'Death in Heaven and Heaven Sent are both Doctor Who stories.',
   'skasis': 'The Skasis Paradigm is the mathematical equation behind the way the universe works.',
   'mcgann': 'Paul McGann played the Eighth Doctor.',
   'beacon': 'The Nerva Beacon space station features in several stories in Tom Baker\'s first season.',
   'gejelh': 'Merry Gejelh is the child chosen to sing to the Old God of Akhaten in the Rings of Akhaten.',
   'oswald': 'Clara Oswald was a companion to the eleventh and twelfth Doctors.',
   'ortron': 'Ortron is Chancellor of Peladon in The Monster of Peladon.',
   'kroton': 'The Krotons are the monsters in The Krotons.',
   'engine': 'The Story and the Engine is a Fifteenth Doctor story.',
   'poison': 'The Poison Sky is a tenth Doctor story.',
   'cherub': 'Cherub versions of the Weeping Angelas appear in The Angels Take Manhattan.',
   'vastra': 'Madame Vastra is a Silurian who leads the Paternoster Gang.',
   'purves': 'Peter Purves played companion Steven Taylor.',
   'morpho': 'The Morpho are a disemboided brain-like creature who ruled the city of Morphoton on Marinus.',
   'arwell': 'The Doctor, the Widow and the Wardrobe centres around the Arwell family.',
   'pocket': 'In Human Nature and Family of Blood the Doctor transfers his Time Lord essence into a Pocket Watch.',
   'walker': 'In the TV Movie the Doctor is taken to Walker General Hospital.',
   'wraith': 'Wraiths inhabit the catacombs on Galligrey.',
   'zellin': 'Zellin and Rakaya are the immortal villains in Can You Hear Me?',
   'garron': 'Garron and Unstoffe are a criminal duo in The Ribos Operation.',
   'kahler': 'The Aliens in A Town called Mercy are both Kahler.',
   'cosmic': 'The Second Doctor was envisioned as a Cosmic Hobo.',
   'doctor': 'Doctor Who?',
   'static': 'In The Daleks the Daleks need static electricty to move.  In Evil of the Daleks Maxtible and Waterfield accidentally bring the Daleks to Earth when trying to invent a time machine using mirrors and static electricity.',
   'cromer': 'The Brigadier mistakes Omega\'s realm for Cromer in The Three Doctors.',
   'lodger': 'The Lodger is an eleventh Doctor story.',
   'ogrons': 'Ogrons are the servants of the Daleks.',
   'robert': 'Robert Holmes script-edited Doctor Who.',
   'inayat': 'The Doctor meets Noor Inayat Khan in Spyfall.',
   'donald': 'Donald Tosh script-edited Doctor Who.',
   'gibson': 'Millie Gibson played companion Ruby Sunday.',
   'kronos': 'Kronos the Chronovore appears in The Time Monster.',
   'newman': 'Doctor Who was the brain child of Syndney Newman.',
   'fenric': 'The Curse of Fenric is a seventh Doctor story.',
   'global': 'Global Chemicals is the source of the contamination that causes the Green Death.',
   'sunday': 'Millie Gibson will played companion Ruby Sunday.',
   'meglos': 'Meglos is a fourth Doctor story.',
   'spiral': 'Mutter\'s Spiral seems to be a synonym for the Milky Way.',
   'norton': 'Graham Norton has appeared several time in Doctor Who.  Once, intentionally.',
   'vortis': 'Vortis is the planet of the Zarbi and the Menoptera in The Web Planet.',
   'dryads': 'The Dryads are beetle creatures that live in the house in Knock Knock.',
   'pepper': 'Lindy Pepper-Bean is the protagonist in Dot and Bubble.',
   'necros': 'Revelation of the Daleks is set on the planet Necros in the funeral home Tranquil Repose.',
   'obrien': 'Graham O\'Brien was a companion to the thirteenth Doctor.',
   'jensen': 'Rachel Jensen is scientific advisor to the Intrusion Counter Measures group in Rememberance of the Daleks.',
   'judoon': 'Fugitive of the Judoon is a thirteenth Doctor story.',
   'retcon': 'Retcon is a substance used to make people forget.  It was used a lot in Torchwood and also in Face the Raven.',
   'mccall': 'Davina McCall appears as herself in The Church on Ruby Road.',
   'bishop': 'John Bishop played companion Dan.',
   'powell': 'Rose and her Mum live on the Powell Estate.',
   'utopia': 'Utopia is a tenth Doctor story.',
   'mirror': 'Mirrors form the interface between E-Space and N-Space in Warriors\' Gate.',
   'signet': 'The first Doctor wore a Signet Ring - also worn by the twelfth Doctor.',
   'sauvix': 'Sauvix is the Sea Devil leader in Warriors of the Deep.',
   'behind': 'Doctor Who is traditionally watched from Behind the Sofa.',
   'hadron': 'The Master uses Hadron Energy to bind Adric in Castrovalva.',
   'ballad': 'The Ballad of the Last Chance Saloon provides a musical backdrop to The Gunfighters.',
   'nathan': 'John Nathan-Turner was a Doctor Who producer.',
   'verity': 'Verity Lambert was the first producer of Doctor Who.',
   'edison': 'Thomas Edison appears as an antagonist in Nikola Tesla\'s Night of Terror.',
   'vaughn': 'Tobias Vaughn is the villian in The Invasion.',
   'battle': 'The Battle of Ranskoor Av Kolos is a thirteenth Doctor story.',
   'teller': 'In Time Heist the Doctor and his friends rescue The Teller.',
   'rounds': 'The Brigadier famously said \'chap with wings, five rounds rapid.\'.',
   'ffinch': 'Polly kidnaps Lt. Algernon Ffinch in The Highlanders.',
   'amelia': 'Amy Pond is called Amelia in her childhood.',
   'sontar': 'Sontar is the home world of the Sontarans.',
   'galaxy': 'Galaxy 4 and The Greatest Show in the Galaxy are both Doctor Who stories.',
   'megara': 'The Megara are Justice Machines in The Stones of Blood.',
   'reaper': 'The Reapers appear where paradoxes arise.',
   'auvers': 'Vincent van Gogh\'s painting The Church at Auvers depicts the Krafayis in Vincent and the Doctor.',
   'ramone': 'Ramone is one of River Song\'s husbands in the Husbands of River Song.',
   'gadget': 'Gadget the Robot appears in The Waters of Mars.',
   'pangol': 'Pangol is the villain in The Leisure Hive.',
   'romans': 'The Romans is a first Doctor story.',
   'memory': 'In Empire of Death, The Doctor, Ruby and Mel take refuge in a Memory Tardis.',
   'leeson': 'John Leeson voiced K9.',
   'temple': 'Donna marries Sean Temple.',
   'autons': 'The Autons are monsters appearing in Spearhead from Space, Terror of the Autons and Rose.',
   'visian': 'The Visians are the invisible inhabitants of the planet Mira in the Daleks\' Masterplan.',
   'gibbis': 'Gibbis is a Cowardly Tivolian in The God Complex.',
   'malone': 'In later life Amy writes Melody Malone mysteries.',
   'josiah': 'Josiah Smith seeks to assassinate Queen Victoria in Ghost Light.',
   'yasmin': 'Yasmin Khan was a companion of the thirteenth Doctor.',
   'asgard': 'The Doctor and River Song had a picnic at Asgard.',
   'tetrap': 'The Tetraps serve the Rani in Time and the Rani.',
   'masque': 'The Masque of Mandragora is a fourth Doctor story.',
   'dulkis': 'Dulkis is the planet invaded by the Dominators.',
   'shoals': 'In The Return of Doctor Mysterio, the Doctor is investigating the company Harmony Shoals.',
   'lilith': 'Lilith is the main Carrionite in The Shakespeare Code.',
   'kragar': 'Kragar is a Sontaran Psychic Surveryor in The Vanquishers.',
   'wester': 'We first meet the Weeping Angels in an abandoned house in Wester Drumlins.',
   'scroll': 'The Black Scrolls of Rassilon reveal the secrets of the Death Zone  on Gallifrey.',

   'orient': 'Mummy on the Orient Express is a twelfth Doctor story.',
   'earpod': 'The Cybermen use EarPods to take control of people in Rise of the Cybermen.',
   'terror': 'The Reign of Terror, The Macra Terror, Terror of the Autons, Terror of the Zygons, Terror of the Vervoids, and Nikola Tesla\'s Night of Terror are all Doctor Who stories.',
   'fariah': 'Fariah is the villain Salamander\'s food taster in Enemy of the WOrld.  She is killed helping Jamie and Victoria escape.',
   'skulls': 'The Tardis crew are held captive in the Cave of Skulls in An Unearthly Child.',
   'carrot': 'Mel makes the Doctor drink carrot juice.',
   'fisher': 'The Fisher King is the monster in Before the Flood.',
   'estram': 'In the King\'s Demons, the Master disguises himself as Sir Gilles Estram.',
   'family': 'The Family of Blood is a tenth Doctor story.',
   'hellia': 'The Planet Hellia is a planet exploited by the corportation that sponsors the Interstellar Song Contest.',
   'alfava': 'The Time of Angels and Flesh and Stone take place on the planet Alfava.',
   'voyage': 'Voyage of the Damned is a tenth Doctor story.',
   'stubbs': 'Stubbs and Cotton are two sympathetic guards in The Mutants.',
   'khalid': 'The Master disguises himself as Khalid in Time Flight.',
   'atrios': 'Atrios and Zeos are two planets at war in The Armageddon Factor.',
   'hobson': 'Hobson is the base commander in The Moonbase.',
   'zombie': 'Time Zombies appear in Journey to the Centre of the TARDIS.',
   'flavia': 'Chancellor Flavia was appointed acting President of the Time Lords by the Doctor in The Five Doctors.',
   'kembel': 'Kembel is the planet where the Daleks assemble their alliance in the Daleks\' Masterplan.',
   'sirius': 'Sirius IV is mentinoed in Frontier in Space and Sirius V in City of Death.',
   'talbot': 'Ann Talbot is Nyssa\'s double in The Black Orchid.',
   'factor': 'The Armageddon Factor is a fourth Doctor story.',
   'hobbes': 'Professor Hobbes and his student Dee Dee Biasco are two of the shuttle passengers in Midnight.',
   'anneke': 'Anneke Wills played companion Polly.',
   'billie': 'Billie Piper played companion Rose Tyler.',
   'osiran': 'Sutekh from the Pyramids of Mars is an Osiran.',
   'uvanov': 'Uvanov is commander of the Sandminer in Robots of Death.',
   'jungle': 'The Tardis crew find one of the keys to the Conscience of Marinus in the Screaming Jungle.',
   'enough': 'World Enough and Time is a twelfth Doctor story.',
   'maddox': 'Judy Maddox is the head of human resources at Kerblam.',
   'atraxi': 'The Atraxi appear in The Eleventh Hour.',
   'kaleds': 'The Daleks are mutated Kaleds.',
   'alaska': 'Oswin, one of the fragments of Clara, thought she was a survivor of the crash of the Alaska into the Dalek prison planet.',
   'hybrid': 'There is a Gallifreyan Prophesy that a hybrid creature would stand over the ruins of Gallifrey and unravel the Web of Time.  The creature is referred to as The Hybrid.',
   'jacobi': 'Derek Jacobi played Professor Yana who was revealed as the Master.',
   'cherry': 'Carla Sunday is Ruby\'s grandmother.',
   'deadly': 'The Deadly Assassin is a fourth Doctor story.',
   'heriot': 'Zoe Heriot was a companion to the second Doctor.',
   'saucer': 'The Dalek Saucer appears in The Dalek Invasion of Earth.',
   'thames': 'The Racnoss Empress is hidden under the Thames Barrier.',
   'kraals': 'The Kraals appear in The Android Invasion.',
   'elders': 'The Elders govern the parasitic civilisation in The Savages.',
   'verney': 'Andrew Verney is Tegan\'s grandfather.',
   'listen': 'Listen is a twelfth Doctor story.',
   'davina': 'Davina McCall appears as herself in The Church on Ruby Road.',
   'rosita': 'Rosita Farisi is Jackson Lake\'s companion in the Next Doctor.',
   'dibber': 'Dibber is Glitz\'s partner in The Mysterious Planet.',
   'school': 'School Reunion is a tenth Doctor story.',
   'menace': 'The Underwater Menace is a second Doctor story.',
   'father': 'Father\'s Day is a ninth Doctor story.',
   'matron': 'Matron Casp is the villain in New Earth and Matron Cofelia is the villain in Partners in Crime.',
   'osgood': 'Corporal Osgood is a UNIT Technical Officer in The Daemons.  Petronella Osgood who may (or may not) be related, is UNIT\'s Scientific Advisor under Kate Stewart.',
   'savage': 'Becka Savage, landowner, magistrate and prosecutor of witch trials, is taken over by the Morax in The Witchfinders.',
   'chiang': 'The Talons of Weng-Chiang is a fourth Doctor story.',
   'philip': 'Philip Hinchcliffe was a Doctor Who producer.',
   'stairs': 'Not as often a problem for Daleks as some people think.',
   'raston': 'The Raston Warrior Robot appears in the Five Doctors.',
   'traken': 'The Keeper of Traken is a fourth Doctor story.',
   'vislor': 'Vislor Turlough was a companion to the fifth Doctor.',
   'morton': 'Peter Purves appears as annoying tourist Morton Dill in The Chase before reappearing as new companion Steven Taylor later in the same story.',
   'tremas': 'Tremas is Nyssa\'s father in The Keeper of Traken.  His body is taken over by the Master.',
   'editor': 'The Editor runs Satellite 5 for the Jagrafess in The Long Game.',
   'eldrad': 'Eldrad is the villain in The Hand of Fear.',
   'biasco': 'Professor Hobbes and his student Dee Dee Biasco are two of the shuttle passengers in Midnight.',
   'marter': 'Ian Marter played companion Harry Sullivan.',
   'aliens': 'Aliens of London is a ninth Doctor story.',
   'artron': 'Artron Energy is a form of mental energy utilised by the Time Lords.',
   'tissue': 'The Master\'s signature weapon is the Tissue Compression Eliminator.',
   'osiris': 'Phaester Osiris is the home planet of the Osirans.',
   'thalia': 'Chancellor Thalia is a Time Lord in Arc of Infinity.',
   'stooky': 'Stooky Bill is the puppet used by John Logie Baird that starts the Giggle.',
   'punjab': 'Demons of the Punjab is a thirteenth Doctor story.',
   'sphere': 'The Sense Sphere (from the Sensorites) and the Ood Sphere (from Planet of the Ood) are both planets.',
   'yonder': 'Wild Blue Yonder is a Fourteenth Doctor Story.',
   'aldred': 'Sophie Aldred played companion Ace.',
   'orchid': 'Black Orchid is a fifth Doctor story.',
   'lupton': 'Lupton is the villain in Planet of the Spiders',
   'halpen': 'Mr Halpen is the president of Ood Industries in Planet of the Ood.  The Ood turn him into an Ood.',
   'laszlo': 'Laszlo is Tallulah\'s missing boyfriend in Daleks in Manhattan.  He has been transformed into a pig man.',
   'adeola': 'Martha\'s cousin Adeola appears in Army of Ghosts, also played by Freema Agyeman.',
   'corral': 'The events of The Gunfighters lead up to the gunfight at the O.K. Corral.',
   'novice': 'Novice Hame is a Cat Nun who appears in New Earth and Gridlock.',
   'dances': 'The Doctor Dances is a ninth Doctor story.',
   'frazer': 'Frazer Hines played companion Jamie.',
   'gravis': 'Gravis is the leader of the Tractators in Frontios.',
   'police': 'The Tardis is disguised as a Police Public Call Box.',
   'wenley': 'Wenley Moor Nuclear Research Facility appears in The Silurians.',
   'gracht': 'Count Grendal of Gracht is the villain in The Androids of Tara.',
   'london': 'Aliens of London is a ninth Doctor story.',
   'nation': 'Terry Nation invented the Daleks.',
   'styles': 'Day of Daleks involves time travellers attempting to assassinate diplomat Sir Reginald Styles.',
   'nature': 'Human Nature is a tenth Doctor story.',
   'silent': 'The Silent are the individual members of The Silence.',
   'zhukov': 'Captain Zhukov commands the submarine in Cold War.',
   'ghosts': 'Army of Ghosts is a tenth Doctor story.',
   'cotton': 'Stubbs and Cotton are two sympathetic guards in The Mutants.',
   'levene': 'Jon Levene played UNIT sergeant Benton.',
   'audrey': 'Ace\'s mother was called Audrey.  Ace met her as a baby in The Curse of Fenric.',
   'change': 'Change, my dear, and not a moment too soon.',
   'louvre': 'The City of Death involves the theft of the Mona Lisa from the Louvre.',
   'cryons': 'The Cryons lived on Telos before the Cybermen came.',
   'duggan': 'Duggan is a detective, somewhat prone to smashing things, in City of Death.',
   'hitler': 'Let\'s Kill Hitler is an eleventh Doctor story.',
   'attack': 'Attack of the Cybermen is a sixth Doctor story.',
   'claire': 'Claire is a recurring character in Flux.',
   'totter': 'In the first episode the Tardis is in Totter\'s Yard.',
   'karfel': 'The Doctor and Peri visit Karfel in Timelash.',
   'crater': 'The Menoptera were kept prisoners by the Zarbi in the Crater of Needles.',
   'ganger': 'The Gangers are human controlled Doppelgangers created from the Flesh.',
   'rorvik': 'Rorvik is the villain in Warriors\' Gate.',
   'zaroff': 'Zaroff is the villain in The Underwater Menace.  He got to say \'Nothing the the World can stop me now!\'',
   'kizlet': 'Miss Kizlet is the front for the Great Intelligence in the Bells of St. John.',
   'robber': 'The Mind Robber is a second Doctor story.',
   'benton': 'Sergeant Benton was a recurring UNIT character.',
   'towers': 'Paradise Towers is a seventh Doctor story.',
   'miller': 'Louise Miller is Ruby Sunday\'s birth mother.',
   'circus': 'The Doctor and Ace visit the Psychic Circus in The Greatest Show in the Galaxy.',
   'wrarth': 'The Wrath Warriors are monsters in The Star Beast.',
   'source': 'The Source is a terraforming device in The Doctor\'s Daughter.',
   'xerons': 'The Xerons appear the The Space Museum.',
   'vogans': 'The Vogans appear in Revenge of the Cybermen.',
   'agatha': 'The Doctor meets Agatha Christie in the Unicorn and the Wasp.',
   'steven': 'Steven Taylor was a companion to the first Doctor.',
   'matrix': 'The Matrix on Gallifrey holds the combined knowledge of the Time Lords.',
   'tyburn': 'Sam Swift is to be hung at Tyburn before being saved by the Doctor and Me in The Woman Who Lived.',
   'puddle': 'Bill\'s girlfriend Heather is taken over by puddle of sentient engine oil.',
   'sharaz': 'Sharaz Jek is the tragic villain in The Caves of Androzani.',
   'polish': 'Polish! Polish!',
   'robson': 'Robson is in charge of the gas refinery in Fury from the Deep.',
   'dennis': 'Dennis Spooner script-edited Doctor Who.',
   'demons': 'The King\'s Demons and Demons of the Punjab are both Doctor Who stories.',
   'eocene': 'A period of Earth\'s history from which the Silurians probably didn\'t originate and so they shouldn\'t be called Eocenes either.',
   'astrid': 'Kylie Minogue plays Astrid Peth in Voyage of the Damned.',
   'jackie': 'Jackie Lane played companion Dodo Chaplet.',
   'holmes': 'Robert Holmes script-edited Doctor Who.',
   'cooper': 'Gwen Cooper appears in the Stolen Earth and Journey\'s End as well as being one of the main characters in Torchwood.',
   'stones': 'The Stones of Blood is a fourth Doctor story.',
   'gavrok': 'Gavrok leads the Bannermen in Delta and the Bannermen.',
   'rakaya': 'Zellin and Rakaya are the immortal villains in Can You Hear Me?',
   'lurman': 'Vorg and Shirna in Carnival of Monsters are Lurmans.',
   'oxygen': 'Oxygen is a twelfth Doctor story.',
   'davros': 'Davros is the creater of the Daleks.',
   'thoros': 'Mindwarp takes place on Thoros Beta.',
   'flight': 'Time-Flight is a fifth Doctor story.',
   'damned': 'Voyage of the Damned is a tenth Doctor story.',
   'devils': 'The Sea Devils and Legend of the Sea Devils are both Doctor Who stories.',
   'martin': 'Jo Martin plays the Fugitive Doctor in Fugitive of the Judoon.',
   'bysshe': 'The Doctor meets Percey Bysshe Shelley in the The Haunting of Villa Diodati.',
   'krasko': 'Krasko is the antagonist in Rosa.',
   'giggle': 'The Giggle is a Fourteenth Doctor story.',
   'isolus': 'Chloe Webber is possessed by an Isolus in Fear Her.',
   'animus': 'The Animus is the enemy in the Web Planet.',
   'drahva': 'Drahva is the home of the Drahvins.',
   'melody': 'Amy and Rory name their daughter Melody.',
   'shakri': 'Shakri cubes appear all over the Earth in the Power of Three.',
   'monoid': 'The Monoids are the monsters in The Ark.',
   'newton': 'Isaac Newton appears (briefly) in Wild Blue Yonder.',
   'master': 'The Master is the Doctor\'s Arch enemy.',
   'huffle': 'In The Return of Doctor Mysterio, Lucy interogates the Doctor by squeezing a Mr. Huffle toy.',
   'system': 'Mavic Chen is Guardian of the Solar System.',
   'lupari': 'Karvanista in Flux is a member of the Lupari race.',
   'melkur': 'The Melkur is a disguise for the Master\'s Tardis in The Keeper of Traken.',
   'rutans': 'The Rutans are the enemies of the Sontarans.',
   'prison': 'The Doctor spends a long time in Prison, most notably between The Timeless Children and Revolution of the Daleks.',
   'hungry': 'The Hungry Earth is an eleventh Doctor story.',
   'gilles': 'In the King\'s Demons, the Master disguises himself as Sir Gilles Estram.',
   'beetle': 'A Time Beetle appears in Turn Left.',
   'triton': 'Triton is a city on Neptune.  The soldiers in Sleep No More are sent from there.',
   'skovox': 'The Skovox Blitzer is the monster in The Caretaker.',
   'oberon': 'Orcini is a Knight of Oberon in Revelation of the Daleks.',
   'sydney': 'Doctor Who was the brain child of Syndney Newman.',
   'mickey': 'Mickey Smith is Rose\'s boyfriend and briefly a companion of the Doctor.',
   'sidrat': 'The SIDRAT\'s were the War Lord\'s time and space machines in The War Games.',
   'bunker': 'The Bunker is the location for all scientific research on Skaro at the time of the creation of the Daleks.',
   'vortex': 'The Tardis travels through the Time Vortex.',
   'hydrax': 'The Tower of the Lords in State of Decay is actually the spaceship Hydrax.',
   'varada': 'Varada Sethu will play a new companion in the 2025 season.',
   'mestor': 'Mestor is the leader of the Giant Gastropods in The Twin Dilemma.',
   'vivien': 'Vivien Fay is the identity assumed by Cessair of Diplos in The Stones of Blood.',
   'guitar': 'The Twelfth Doctor often played a guitar.',
   'second': 'The Second Doctor was played by Patrick Troughton.',
   'moment': 'The Doctor contemplates using the Moment to end the Time War.',
   'zeiton': 'Zeiton-7 ore is vital for realigning the power systems of time machines.',
   'called': 'A Town Called Mercy is an eleventh Doctor story.',
   'chance': 'The Ballad of the Last Chance Saloon provides a musical backdrop to The Gunfighters.',
   'george':  'A Tenza child becomes the terrified George in Night Terrors.',
   'canary': 'The Battle of Canary Wharf between the Daleks and the Cybermen takes place during Doomsday.',
   'shooty': 'K9 is referred to as the Shooty Dog Thing in School Reunion.',
   'pharos': 'The Fourth Doctor regenerates when he falls from the antenna of the Pharos Project.',
   'restac': 'Restac is a Silurian Warrior Leader in Cold Blood.',
   'farisi': 'Rosita Farisi is Jackson Lake\'s companion in the Next Doctor.',
   'millie': 'Millie Gibson played companion Ruby Sunday.',
   'gordon': 'Alister Gordon Lethbridge-Stewart is the Brigadier\'s full name.',
   'patrol': 'The Happiness Patrol is a seventh Doctor story.',
   'huasen': 'The Huasen is a massive sea beast used by the Sea Devils in Legend of the Sea Devils.',
   'detsen': 'The Detsen Monastery is where the Doctor first meets the Yeti in The Abominable Snowmen.',
   'hamish': 'The Brigadier\'s grandfather is Archibald Hamish Lethbridge-Stewart.',
   'zucker': 'Mels Zucker is a friend of Amy and Rory who turns out to be an early incarnation of River Song.',
   'vulcan': 'Vulcan is the planet in Power of the Daleks.',
   'briggs': 'Nick Briggs voices the Daleks in the modern Doctor Who series.',
   'golden': 'Operation Golden Age are trying to turn back time in Invasion of the Dinosaurs.',
   'kaldor': 'Kaldor is a desert planet in The Robots of Death.',
   'vacuum': 'Travel between E-Space and N-Space is possible through Charged Vaccuum Emboitments.',
   'fourth': 'The Fourth Doctor was played by Tom Baker.',
   'xoanon': 'Xoanon is a crazed computer in The Face of Evil.',
   'xanxia': 'Queen Xanxia is one of the villains in The Pirate Planet.',
   'mavity': 'In Wild Blue Yonder the Doctor and Donna accidentally change thework Gravity to Mavity.',
   'andred': 'Leela, rather implausbily, leaves the Doctor to marry Andred.',
   'angels': 'The Time of Angels, The Angels Take Manhattan and Village of the Angels are all Doctor Who stories.',
   'tivoli': 'Tivoli is the most invaded planet in the galaxy.',
   'choice': 'Amy\'s Choice is an eleventh Doctor story.',
   'tardis': 'The TARDIS is the Doctor\'s space and time machine.',
   'kublai': 'The Doctor meets Kublai Khan in Marco Polo.',
   'karkus': 'The Karkus was a fictional superhero from Zoe\'s time who appears as a character in The Mind Robber.',
   'marius': 'Professor Marius created K9',
   'hecate': 'Nightmare of Eden involes a collision between the space ships Empress and Hecate.',
   'legend': 'Legend of the Sea Devils and the Legend of Ruby Sunday are both Doctor Who stories.',
   'gurney': 'Smallbeer, Ringwood, Gurney - names on gravestones - are the clue to the location of Avery\'s treasure in The Smugglers.',
   'optera': 'The Optera are caterpillar-like relatives of the Menoptera in the Web Planet.',
   'cutler': 'General Cutler is the leader of Snowcap Base in The Tenth Planet.',
   'tharil': 'The Tharils are time sensitives in Warriors\' Gate.',
   'kazran': 'Kazran is the antagonist in A Christmas Carol.',
   'foster': 'Mrs Foster is the Adipose Nanny in Partners in Crime.',
   'ingrid': 'Ingrid Oliver plays Osgood - UNIT Scientist and Zygon.',
   'orcini': 'Orcini is an ageing mercenary in Revelation of the Daleks.',
   'eighth': 'Paul McGann played the Eighth Doctor.',
   'sutton': 'Sarah Sutton played companion Nyssa.',
   'shadow': 'The Shadow Proclamation are a universal police force.',
   'smiler': 'The Winders were the police force of Starship UK.  They were half-human half-Smiler cyborgs.',
   'joanna': 'Jean Marsh plays Richard the Lionheart\'s sister Joanna in The Crusade.',
   'spider': 'Giant Spiders are the monsters in Planet of the Spiders',
   'tomtit': 'TOMTIT is a device for manipulating time in The Time Monster.',
   'sutekh': 'Sutekh the Destroyer is the villain in Pyramids of Mars.',
   'makers': 'The Myth Makers and the Sun Makers are both Doctor Who stories.',
   'zondal': 'Zondal is an Ice Warrior in The Ice Warriors.',
   'tracer': 'The Tracer is used to detect segments of the Key to Time.',
   'allons': 'The Tenth Doctor often said Allons-y.',
   'victor': 'Victor Pemberton script-edited Doctor Who.',
   'diplos': 'Vivien Fay is the identity assumed by Cessair of Diplos in The Stones of Blood.',
   'qurunx': 'The Qurunx is an energy being enslaved by the Master in The Power of the Doctor.',
   'nunton': 'The Nunton Experimental Complex is the setting for much of The Hand of Fear.',
   'undead': 'Mawdryn Undead is a fifth Doctor story.',
   'pirate': 'The Pirate Planet is a fourth Doctor story.',
   'quarks': 'The Quarks are the robot servants of the Dominators.',
   'iraxxa': 'Iraxxa is the Empress of the Ice Warriors.',
   'babies': 'Space Babies is a Fifteenth Doctor story.',
   'romana': 'Romana was a companion to the fourth Doctor.',
   'panama': 'The fifth Doctor wore a Panama Hat.',
   'minyan': 'The Minyans come from Minyos.',
   'medusa': 'The Daleks move 27 planets to the Medusa Cascade in The Stolen Earth.',
   'vinder': 'Vinder was a recurring character in Flux.',
   'oliver': 'Ingrid Oliver plays Osgood - UNIT Scientist and Zygon.',
   'asylum': 'Asylum of the Daleks is an eleventh Doctor story.',
   'estate': 'Tooth and Claw takes place on the Torchwood Estate.',
   'museum': 'The Space Museum is a first Doctor story.',
   'gerald': 'Gerald Flood voiced Kamelion.',
   'simeon': 'Dr Simeon is taken over by the Great Intelligence in The Snowmen which continues to use his body in The Name of the Doctor.',
   'puzano': 'Belle leaves a message for Vinder on Puzano in Village of the Angels.',
   'shirna': 'Vorg and Shirna bring a miniscope to Inter Minor in Carnival of Monsters.',
   'tegana': 'Tegana is the villain in Marco Polo.',
   'giants': 'Planet of Giants was a first Doctor story.',
   'zygons': 'Terror of the Zygons is a fourth Doctor story.',
   'centre': 'Journey to the Centre of the TARDIS is an elevent Doctor story.',
   'schism': 'The Master was driven mad when he gazed into the Untempered Schism as a child.',
   'brooke': 'Adelaide Brooke is a pseudo-companion in The Waters of Mars.',
   'barber': 'The Barber is the villain in The Story and the Engine.',
   'morris': 'Morris Gibbons is the UNIT scientific advisor in The Legend of Ruby Sunday and Empire of Death.',
   'cicero': 'Eve Cicero is a renowned general who dies to save the Tsuranga in The Tsuranga Conundrum.',
   'gillan': 'Karen Gillan played companion Amy Pond.',
   'wright': 'Barbara Wright was a companion to the first Doctor.',
   'palmer': 'Professor Alec Palmer is conducting pyschic experiments in Hide.',
   'circle': 'Full Circle is a fourth Doctor story.',
   'morlox': 'The Molox lizards appear in Timelash.',
   'kaftan': 'Kaftan is one of the villains in Tomb of the Cybermen.',
   'nikola': 'Nikola Tesla\'s Night of Terror is a thirteenth Doctor story.',
   'planet': 'Planet of Giants, The Web Planet, The Tenth Planet, Planet of the Daleks, Planet of the Spiders, Planet of Evil, The Pirate Planet, Planet of Fire, The Mysterious Planet, The Impossible Planet, Planet of the Ood, and Planet of the Dead are all Doctor Who stories.',
   'manish': 'Manish is the antagonist in Demons of the Punjab.',
   'taylor': 'Steven Taylor was a companion to the first Doctor.',
   'aztecs': 'The Aztecs was a first Doctor story.',
   'covent': 'WOTAN builds War Machines in a Warehouse near Covent Garden in The War Machines.  The travellers land at the tube station in The Web of Fear.',
   'eaters': 'The Eaters of Light is a twelfth Doctor story.',
   'dorium': 'Dorium Maldovar was a somewhat unwilling ally of the eleventh Doctor.',
   'things': 'The Journal of Impossible Things was a dream diary kept by the Tenth Doctor\'s human persona, John Smith, in The Family of Blood.',
   'forest': 'Forest of the Dead and In the Forest of the Night are both Doctor Who stories.',
   'tobias': 'Tobias Vaughn is the villian in The Invasion.',
   'skagra': 'Skagra is the villain in the untransmitted story Shada.',
   'yvonne': 'Yvonne Hartman leads Torchwood in Army of Ghosts and Doomsday.',
   'nimrod': 'Nimrod is a neanderthal acting as a manservant in Ghost Light.',
   'bryant': 'Nicola Bryant played companion Peri Brown.',
   'reimer': 'Kartz and Reimer\'s time travel experiments cause the Time Lords to send the Doctor and Jamie to intervene in The Two Doctors.',
   'canton': 'Canton Everett helps the Doctor in The Impossible Planet and Day of the Moon.',
   'sylvia': 'Sylvia Noble is Donna\'s mother.',
   'goblin': 'Goblins are the enemy in The Church on Ruby Road.',
   'kelner': 'Castellan Kelner serves the invaders of Gallifrey in The Invasion of Time.',
   'icthar': 'Icthar is the Silurian leader in Warriors of the Deep.',
   'yartek': 'Yartek is leader of the alien Voord.',
   'ainley': 'Anthony Ainley played the Master in the 1980s.',
   'tahira': 'Tahira helps the Doctor in Can You Hear Me?',
   'daleks': 'The Daleks are the Doctor\'s arch enemies and first appear in The Daleks.',
   'fungus': 'In the Seeds of Death the Ice Warriors release a fungus to remove the Oxygen from the Earth.',
   'daphne': 'Daphne Ashbrook played companion Grace.',
   'merlin': 'In Battlefied it is revealed that a future Doctor is Merlin.',
   'church': 'The Church on Ruby Road is a Fifteenth Doctor story.',
   'vardan': 'The Vardans invade Gallifrey in The Invasion of Time.',
   'sophie': 'Sophie Aldred played companion Ace.',
   'moroks': 'The Moroks are the rulers of Xeros in the Space Museum.',
   'azmael': 'Azmael is an old friend of the Doctor\'s forced to help the evil giant Gastropods in The Twin Dilemma.',
   'graham': 'Graham O\'Brien was a companion to the thirteenth Doctor.',
   'ursula': 'Ursula Blake is Elton Pope\'s love interest in Love and Monsters.',
   'keller': 'The Keller machine holds the Mind of Evil.',
   'legion': 'In The Eaters of Light the remains of the Roman Ninth Legion help hold back the Eater inside a pictish cairn.',
   'kassia': 'Kassia is Nyssa\'s step-mother and pawn of the Master in The Keeper of Traken.',
   'empire': 'Empire of Death is a Fifteenth Doctor story.',
   'cusick': 'Ray Cusick was responsible for the iconic Dalek design.',
   'borusa': 'Borusa is a high ranking Time Lord, former tutor of the Doctor and ultimately the villain in the Five Doctors.',
   'jarvis': 'Jarvis Bennet is controller of the Wheel in Space.',
   'morgus': 'Morgus is the villain in The Caves of Androzani.',
   'waters': 'The Waters of Mars is a tenth Doctor story.',
   'wenger': 'Piers Wenger was an executive producer of Doctor Who.',
   'nicola': 'Nicola Bryant played companion Peri Brown.',
   'mondas': 'Mondas is the home of the Cybermen.',
   'murray': 'Murray Gold composed Doctor Who\'s incidental music from the start of the ninth Doctor\'s episodes to the end of the twelfth.',
   'winder': 'The Winders were the police force of Starship UK.  They were half-human half-Smiler cyborgs.',
   'gundan': 'The Gundan robots were designed to travel the time winds and destory the brutes who rule in Warriors\' Gate.',
   'turner': 'John Nathan-Turner was a Doctor Who producer.',
   'yetaxa': 'In the Aztecs, Barbara is mistaken for a reincarnation of the high priest Yetaxa.',
   'robots': 'The Robots of Death is a fourth Doctor story.',
   'dukkha': 'Dukkha is a representation of the Mara in Kinda.',
   'daniel': 'Daniel Barton, played by Lenny Henry is the antagonist in Spyfall.',
   'shallo': 'Shallo is a Sontaran in The Vanquishers.  He is caught looting a corner shop for chocolate by the Fam.',
   'lytton': 'Lytton is a Space Mercenary who appears in Resurrection of the Daleks and Attack of the Cybermen.',
   'mentor': 'The Mentors, including Sil and Kiv, control Thoros Beta in Mindwarp.',
   'bonnie': 'Bonnie Langford played companion Mel Bush.',
   'bubble': 'Dot and Bubble is a Fifteenth Doctor story.',
   'moffat': 'Steven Moffat was the showrunner for the eleventh and twelfth Doctor series.',
   'broton': 'Broton is the leader of the Zygons in Terror of the Zygons.',
   'azaxyr': 'Azaxyr is an Ice Lord in Monster of Peladon',
   'magpie': 'The Wire operates out of Magpie Electronics in The Idiot\'s Lantern.',
   'carole': 'Carole Ann Ford played Susan, the Doctor\'s granddaughter.',
   'saloon': 'The Ballad of the Last Chance Saloon provides a musical backdrop to The Gunfighters.',
   'davies': 'Russell T Davies was the showrunner who brought back Doctor Who.',
   'harold': 'Harold Saxon is the Master in disguise.',
   'colony': 'Colony in Space is a third Doctor story.',
   'vashta': 'The Vashta Nerada are the monsters in Silence in the Library and Forest of the Dead.',
   'bessie': 'The Third Doctor\'s Edwardian Roadster is called Bessie.',
   'acteon': 'Metebelis 3 is the famous blue planet in the Acteon Galaxy.',
   'louise': 'Louise Jameson played companion Leela.',
   'breath': 'Deep Breath is a twelfth Doctor story.',
   'tekker': 'Tekker is the ambitious leader of Karfel in Timelash.',
   'forced': 'In Power of the Doctor the Master uses a forced regeneration to steal the Doctor\'s body.',
   'henrik': 'At the start of the modern series, Rose works in Henrik\'s department store.',
   'bellal': 'The Exxilon Bellal helps the Doctor in Death to the Daleks.',
   'viking': 'The Meddling Monk tries to alter history in the Time Meddlar by defeating the Viking invasion by Harald Hardrada using a missile.',
   'hoothi': 'In The Brain of Morbius the Sisterhood of Karn claim to be able to detect the silent gas dirigibles of the Hoothi.',
   'silver': 'Silver Nemesis and Nightmare in Silver are both Doctor Who stories.',
   'stolen': 'The Stolen Earth is a tenth Doctor story.',
   'finney': 'Yasmin Finney will play Rose in the Doctor Who specials in 2023.',
   'repose': 'Revelation of the Daleks is set on the planet Necros in the funeral home Tranquil Repose.',
   'rescue': 'The Rescue is a first Doctor story.',
   'return': 'The Return of Doctor Mysterio is a twelfth Doctor story.',
   'cameca': 'The Doctor accidentally becomes engaged to Cameca in The Aztecs.',
   'sharon': 'Amy Pond is raised by her Aunt Sharon after her parents disappear into the crack in her wall.',
   'clever': 'Run you clever boy and remember me.',
   'goodge': 'The army base in The Web of Fear is under Goodge Street tube station.',
   'freema': 'Freema Agyeman played companion Martha Jones.',
   'random': 'In Extremis the simulation\'s inhabitants work out they are simulations because they all pick the same random number.',
   'minyos': 'The planet Minyos was destroyed after the Time Lords interfered with its development.',
   'people': 'The Almost People is an eleventh Doctor story.',
   'almost': 'The Almost People is an eleventh Doctor story.',
   'effect': 'The Blinovitch Limitation Effect regulates time travel.',
   'dhawan': 'Sacha Dhawan played the Master opposite Jodie Whittaker\'s Doctor.',
   'martha': 'Martha Jones was a companion to the tenth Doctor.',
   'sladen': 'Elizabeth Sladen played companion Sarah Jane Smith.',
   'mandip': 'Mandip Gill played companion Yaz Khan.',
   'mackie': 'Pearl Mackie played companion Bill Potts.',
   'nerada': 'The Vashta Nerada are the monsters in Silence in the Library and Forest of the Dead.',
   'larvae': 'The Zarbi used Larvae guns in The Web Planet.',
   'hearts': 'The Knave, King and Queen of Hearts appear in The Celestial Toymaker.',
   'saward': 'Eric Saward script-edited Doctor Who.',
   'andrew': 'Andrew Cartmel script-edited Doctor Who.',
   'stenza': 'Tzim-Sha in the Woman who Fell to Earth is a Stenza.',
   'keeper': 'The Keeper of Traken is a fourth Doctor story.',
   'shreek': 'The Shreek is a monster in Lucky Day.',
   'celery': 'The Fifth Doctor wore a stick of celery on his lapel.',
   'barton': 'Daniel Barton, played by Lenny Henry is the antagonist in Spyfall.',
   'before': 'Before the Flood is a twelfth Doctor story.',
   'hazran': 'Hazran is a Mondasian who takes a liking to Nardole in The Doctor Falls.',
   'helmic': 'The Helmic Regulator controls the accuracy of flight through the vortex.',
   'magnus': 'Magnus Greel is the villain in The Talons of Weng-Chiang.',
   'scorby': 'Scorby is Harrison Chase\'s henchman in The Seeds of Doom.',
   'horror': 'Horror of Fang Rock and The Crimson Horror are both Doctor Who stories.',
   'orphan': 'Orphan 55 is a thirteenth Doctor story.',
   'daemon': 'Azal is a Daemon.',
   'arthur': 'Arthur Darvill played companion Rory Williams.',
   'conrad': 'Conrad Clark is the villain in Lucky Day and Wish World.',
   'hepesh': 'Hepesh is the high priest of Peladon in The Curse of Peladon.',
   };
